<template>
    <div>
        <div>
            <div class="tw-flex tw-flex-row-reverse tw-mb-2 tw-px-2 tw-justify-between">
                <div class="tw-w-1/3">
                    <table class="tw-table-auto tw-min-w-full tw-text-right tw-text-sm tw-font-light">
                        <thead class="tw-font-medium tw-dark:border-neutral-500">
                            <tr>
                                <th scope="col" class="tw-pb-2"></th>
                                <th scope="col" class="tw-pl-4 tw-pb-2">Days Worked</th>
                                <th scope="col" class="tw-pl-4 tw-pb-2">Dues</th>
                                <th scope="col" class="tw-pl-4 tw-pb-2">Training</th>
                                <th scope="col" class="tw-pl-4 tw-pb-2">Levy</th>
                                <th scope="col" class="tw-pl-4 tw-pb-2">Levy GST</th>
                                <th scope="col" class="tw-pl-4 tw-pb-2">Balance</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="tw-text-secondary font-weight-black tw-pl-2">Totals</td>
                                <td class="tw-text-secondary font-weight-black tw-pl-4">{{ toFixedNumDecimals(summary_data?.days_worked, 0) }}</td>
                                <td class="tw-text-secondary font-weight-black tw-pl-4">{{ $root.formatCurrency(summary_data?.dues_amount) }}</td>
                                <td class="tw-text-secondary font-weight-black tw-pl-4">{{ $root.formatCurrency(summary_data?.training_amount) }}</td>
                                <td class="tw-text-secondary font-weight-black tw-pl-4">{{ $root.formatCurrency(summary_data?.levy_amount) }}</td>
                                <td class="tw-text-secondary font-weight-black tw-pl-4">{{ $root.formatCurrency(summary_data?.levy_gst) }}</td>
                                <td class="tw-text-secondary font-weight-black tw-pl-4">{{ $root.formatCurrency(summary_data?.balance_amount) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="tw-flex tw-gap-2 tw-items-end">
                    <date-picker
                        v-model="filters.date_deposit"
                        :yearOnly="true"
                        min="2000"
                        :max="`${new Date().getFullYear() }`"
                        clearable
                        dense
                        color="primary"
                        label="Filter Year"
                        display-label="Filter Year"
                        ref="dateDepositPicker"
                        hide-details="auto"
                    />
                    <v-autocomplete
                        v-model="filters.month_deposit"
                        :items="month_list"
                        dense
                        clearable
                        color="primary"
                        label="Filter Months"
                        display-label="Filter Months"
                        hide-details="auto"
                        outlined
                        multiple
                    />
                    <v-autocomplete
                        v-model="filters.productions"
                        :items="production_list"
                        dense
                        clearable
                        color="primary"
                        label="Filter Productions"
                        display-label="Filter Productions"
                        hide-details="auto"
                        outlined
                        multiple
                        :loading="is_loading"
                        :disabled="is_loading"
                    />
                </div>
            </div>

            <smart-table
                ref="table_dues"
                endpoint="memberdataexcel.list"
                :headers="headers"
                :options_payload="{only_working_dues:true}"
                @fetch-complete="summarizeData"
                :items-per-page="getDefaultItemsPerPage()"
                item-key="member_data_excels_id"
                :footer-props="{
                'items-per-page-options': getDefaultItemsPerPageOptions()
            }"
            >
                <template v-slot:item.date_deposit="{ isMobile, item, header, value, index}">
                    <div>{{ $root.getAsIsoDate(value) }}</div>
                </template>
                <template v-slot:item.productions.name="{ isMobile, item, header, value, index}">
                    <div>{{ item.production_name }}</div>
                    <div class="font-weight-light">{{ item.job_category }}</div>
                </template>
                <template v-slot:item.days_worked="{ isMobile, item, header, value, index}">
                    <div>{{ toFixedNumDecimals(Number(value), 0) }}</div>
                </template>
                <template v-slot:item.dues_amount="{ isMobile, item, header, value, index}">
                    <div>{{ $root.formatCurrency(Number(value)) }}</div>
                </template>
                <template v-slot:item.training_amount="{ isMobile, item, header, value, index}">
                    <div>{{ $root.formatCurrency(Number(value)) }}</div>
                </template>
                <template v-slot:item.levy_amount="{ isMobile, item, header, value, index}">
                    <div>{{ $root.formatCurrency(Number(value)) }}</div>
                </template>
                <template v-slot:item.levy_gst="{ isMobile, item, header, value, index}">
                    <div>{{ $root.formatCurrency(Number(value)) }}</div>
                </template>
                <template v-slot:item.balance_amount="{ isMobile, item, header, value, index}">
                    <div>{{ $root.formatCurrency(Number(value)) }}</div>
                </template>
            </smart-table>
        </div>
    </div>

</template>

<script>
    import SmartTable from "@/Generic/SmartTable.vue";
    import DatePicker from "@/Generic/DatePicker.vue";

    export default {
        name: "MembersShowWorkingDues",
        components: {
            DatePicker,
            SmartTable,
        },
        props: {
            'input': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'constants': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'valuelists': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            }
        },
        data() {
            return {
                member: this.input,
                is_loading: true,
                summary_data: null,
                filters: {
                    date_deposit: undefined,
                    month_deposit: undefined,
                    productions: undefined,
                },
                production_list: null,
                month_list: [
                    {text: 'January',   value: '01'},
                    {text: 'February',  value: '02'},
                    {text: 'March',     value: '03'},
                    {text: 'April',     value: '04'},
                    {text: 'May',       value: '05'},
                    {text: 'June',      value: '06'},
                    {text: 'July',      value: '07'},
                    {text: 'August',    value: '08'},
                    {text: 'September', value: '09'},
                    {text: 'October',   value: '10'},
                    {text: 'November',  value: '11'},
                    {text: 'December',  value: '12'},
                ],
            }
        },
        computed: {
            headers() {
                return [
                    {value: 'member_data_excels_id',    text: 'Record ID',                align: `start`,     sortable: true,   filterable: false, },
                    {value: 'batch_id',                 text: 'Batch ID',                 align: `start`,     sortable: true,   filterable: false, },
                    {value: 'date_deposit',             text: 'Week End Date',            align: `start`,     sortable: true,   filterable: true,     search: this.filters.date_deposit },
                    {value: 'productions.name',         text: 'Production & Function',    align: `start`,     sortable: true,   filterable: false, },
                    {value: 'days_worked',              text: 'Days Worked',              align: `end`,       sortable: true,   filterable: false, },
                    {value: 'dues_amount',              text: 'Dues',                     align: `end`,       sortable: true,   filterable: false, },
                    {value: 'training_amount',          text: 'Training',                 align: `end`,       sortable: true,   filterable: false, },
                    {value: 'levy_amount',              text: 'Levy',                     align: `end`,       sortable: true,   filterable: false, },
                    {value: 'levy_gst',                 text: 'Levy GST',                 align: `end`,       sortable: true,   filterable: false, },
                    {value: 'balance_amount',           text: 'Balance',                  align: `end`,       sortable: false,  filterable: false, },
                    {value: 'user_id',                  text: 'User',                     align: ` d-none`,   sortable: true,   filterable: true,     search: this.member.id },
                    {value: 'production_id',            text: 'Production ID',            align: ` d-none`,   sortable: true,   filterable: true,     search: this.filters.productions },
                    {value: 'month_deposit',            text: 'month_deposit',            align: ` d-none`,   sortable: true,   filterable: true,     search: this.filters.month_deposit},
                ]
            },
        },
        mounted() {
            this.getDeferredValuelists()
        },
        methods: {
            formatTimestamp(timestamp) {
                return new Date(timestamp).toISOString().split('T')[0]
            },
            getDefaultItemsPerPage() {
                return this.pdf_view ? -1 : 100
            },
            getDefaultItemsPerPageOptions() {
                return this.pdf_view ? [-1] : [100, 500, 1000]
            },
            summarizeData() {
                this.summary_data = this.$refs.table_dues._data.summary_list
            },
            toFixedNumDecimals(value, num_decimals) {
                if (typeof value !== 'number') return value
                return value.toFixed(num_decimals)
            },
            getDeferredValuelists() {
                axios.post(route('productions.valuelist'))
                    .then((response)=>{
                        this.production_list= response?.data?.map(prod => ({text: prod.text, value: prod.value}))
                        this.is_loading = false
                    })
            },
        },
        watch: {
            input(newInput, oldInput) {
                this.member = newInput
            },

        }
    }
</script>
